import React, { CSSProperties, PropsWithChildren } from 'react';
import styles from './transparent-button.module.scss';

interface TransparentButtonProps extends PropsWithChildren {
  text: string;
  onClick: () => void;
  color?: 'gray' | 'green';
  style?: CSSProperties;
  className?: string;
}

export const TransparentButton: React.FC<TransparentButtonProps> = ({
  text,
  onClick,
  color = 'gray',
  className,
  ...props
}) => {
  const colorClassMap = {
    gray: styles.gray,
    green: styles.green,
  };
  const buttonClass = `${styles.transparent_button} ${colorClassMap[color] || ''} ${className || ''}`;

  return (
    <button className={buttonClass} onClick={onClick} {...props}>
      {text}
    </button>
  );
};
